import React from 'react';
import Popup from './Popup';

type ContractLinkSmsInfoPopupProps = {
    onClose: () => void;
};

export const ContractLinkSmsInfoPopup: React.FC<ContractLinkSmsInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">SMS со ссылкой на документ</h3>

            <div className="security-section">
                <h4 className="Subheader_17">Что делает опция</h4>
                <p>
                    Клиенту уходит SMS со ссылкой на документ — так же, как письмо со ссылкой на email.
                    Сообщение приходит от имени Doki.online.
                </p>
                <p>
                    Текст SMS: «Вам выставили документ на подписание:» и ссылка на документ.
                </p>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Когда отправляется</h4>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px' }}>
                    <li>В кабинете — кнопкой в окне ссылки, на номер, который вы укажете. По умолчанию подставляется телефон клиента из документа.</li>
                    <li>По API — сразу при выставлении документа, если в нём заполнен телефон клиента. Отдельную галочку передавать не нужно.</li>
                </ul>
                <p>
                    Без купленной опции SMS не отправляется. Цена такая же, как у отправки SMS-кода: доплата за каждый документ в пакете.
                </p>
            </div>
        </div>
    </Popup>
);
